
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { Employee } from "../Employee.model";
import { RoomReservationInstance } from "../RoomReservationInstance.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class RoomReservationInst_Emp extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_Employee}-${this.fK_RoomReservationInstance}`;
    }
    return this._id;
  }

  override _isRelationEntity = true; 

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Employee!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_RoomReservationInstance!: number;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  @NestedProperty({ TargetType: RoomReservationInstance })
  roomReservationInstance?: RoomReservationInstance;

  GetType(): IEntityMetaData {
    return RoomReservationInst_Emp.getMetaData();
  }
}
